import React from 'react';
import { Box, Select, MenuItem, InputLabel } from '@mui/material';

// MESSAGES
import MonthFormattedMessages from '../../messages/MonthFormattedMessages';

export default function MonthYearSelector({
  handleInputChange,
  selectedMonth,
  selectedYear,
}) {
  let listYear = [];
  const date = new Date();
  let year = date.getFullYear();
  for (let i = 0; i <= 10; i++) {
    let selectedYear = year - i;
    listYear.push(
      <MenuItem key={selectedYear} value={selectedYear}>
        {selectedYear}
      </MenuItem>
    );
  }

  return (
    <form>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <InputLabel sx={{ margin: 0 }} htmlFor="selectedMonthId">
            Month:
          </InputLabel>

          <Select
            name="selectedMonth"
            id="selectedMonth"
            labelId="selectedMonth"
            value={selectedMonth}
            size="small"
            onChange={handleInputChange}
          >
            <MenuItem value={1}>
              {MonthFormattedMessages.January.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={2}>
              {MonthFormattedMessages.February.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={3}>
              {MonthFormattedMessages.March.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={4}>
              {MonthFormattedMessages.April.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={5}>
              {MonthFormattedMessages.May.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={6}>
              {MonthFormattedMessages.June.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={7}>
              {MonthFormattedMessages.July.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={8}>
              {MonthFormattedMessages.August.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={9}>
              {MonthFormattedMessages.September.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={10}>
              {MonthFormattedMessages.October.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={11}>
              {MonthFormattedMessages.November.props.defaultMessage.toString()}
            </MenuItem>
            <MenuItem value={12}>
              {MonthFormattedMessages.December.props.defaultMessage.toString()}
            </MenuItem>
          </Select>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <InputLabel sx={{ margin: 0 }} htmlFor="selectedYear">
            Year:
          </InputLabel>

          <Select
            name="selectedYear"
            id="selectedYear"
            value={selectedYear}
            size="small"
            onChange={handleInputChange}
          >
            {listYear}
          </Select>
        </Box>
      </Box>
    </form>
  );
}
